import { render } from "./Mb031.vue?vue&type=template&id=9dc5e248"
import script from "./Mb031.vue?vue&type=script&lang=js"
export * from "./Mb031.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__